import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';

interface WorkflowState {
  participantId: string | null;
  attemptNumber: number | null;
}

const initialState: WorkflowState = {
  participantId: null,
  attemptNumber: null
};

export const WorkflowStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setParticipantData(participantId: string, attemptNumber: number) {
      patchState(store, { participantId, attemptNumber });
    },
    setParticipantId(participantId: string) {
      patchState(store, { participantId });
    },
    setAttemptNumber(attemptNumber: number) {
      patchState(store, { attemptNumber });
    },
    reset() {
      patchState(store, initialState);
    }
  }))
);
